import React, { useState } from 'react';
import { Icon } from '../Icon';
import './NotificationTimeSelector.css';

interface NotificationTimeSelectorProps {
  notificationTime?: string;
  transactionType?: 'income' | 'expense';
  onChange: (data: { notificationTime: string }) => void;
  onBack: () => void;
}

export const NotificationTimeSelector: React.FC<NotificationTimeSelectorProps> = ({
  notificationTime = '09:00',
  transactionType,
  onChange,
  onBack
}) => {
  const [time, setTime] = useState(notificationTime);

  const handleSubmit = () => {
    if (!time) return;
    onChange({ notificationTime: time });
  };

  return (
    <div className="notification-time-selector step-content">
      <div className="notification-time-selector__header">
        <button className="notification-time-selector__back neo-raised" onClick={onBack}>
          <Icon name="chevron_left" size={20} />
        </button>
        <div className="notification-time-selector__header-content">
          <h2 className="notification-time-selector__title">Уведомление</h2>
          <p className="notification-time-selector__subtitle">
            {transactionType === 'income' 
              ? 'Когда уведомить о автоматическом доходе?' 
              : 'Когда уведомить о автоматическом платеже?'}
          </p>
        </div>
      </div>

      <div className="notification-time-selector__content">
        <div className="notification-time-selector__info">
          <div className="info-icon"> </div>
          <div className="info-text">
            {transactionType === 'income' 
              ? 'Доход будет добавлен автоматически в это время, и вы получите уведомление' 
              : 'Платеж будет выполнен автоматически в это время, и вы получите уведомление'}
          </div>
        </div>

        <div className="notification-time-selector__input-wrapper">
          <label className="time-input-label">Выберите время:</label>
          <input
            type="time"
            value={time}
            onChange={(e) => setTime(e.target.value)}
            className="time-input neo-inset"
          />
          <div className="time-preview">
            Выбрано: <strong>{time}</strong>
          </div>
        </div>
      </div>

      <button
        className="notification-time-selector__submit neo-raised"
        onClick={handleSubmit}
        disabled={!time}
      >
        Далее
      </button>
    </div>
  );
};

